<template>
  <div class="h-1.5 rounded-b-lg bg-s-200">
    <div
      ref="progressBar"
      class="animate-bar h-full w-full origin-left rounded-full rounded-tl-none bg-p-500"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = defineProps<{
  duration: string
}>()

const progressBar = ref<HTMLDivElement | null>(null)

onMounted(() => {
  if (progressBar.value) {
    progressBar.value.style.animation = `bar-animation ${props.duration} infinite linear`
  }
})
</script>

<style>
@keyframes bar-animation {
  0% {
    transform: scaleX(0);
  }

  99% {
    transform: scaleX(0.99);
    border-top-right-radius: 9999px;
  }

  100% {
    transform: scaleX(1);
    border-top-right-radius: 0;
  }
}
</style>
